<srm-footer [enableSupportTickets]="isSupplierTicketingEnabled"></srm-footer>